export const colors = {
  audience: [
    '#0b406b',
    '#26aafe',
    '#4cc9f1',
    '#7fe7eb',
    '#3296e2',
    '#2dc5ff'
  ],
  creator: [
    '#13503c',
    '#00d09e',
    '#02a57d',
    '#94f7d8',
    '#46e2bc',
    '#dafff6',
    '#b9f9eb'
  ],
  budget: []
};
